<!-- Landing page simple (style DPP) -->
@if (useSimpleLandingStyle()) {
<header
	class="w-full h-[98vh] bg-[url('/images/hero1.png')] bg-cover bg-center bg-no-repeat flex items-center justify-center relative !mb-0">
	<div class="container">
		<img class="w-[320px]" src="images/welcome-txt.svg" alt="" />
		<h1 class="my-3 text-white text-primary">sur le portail du Dossier <br />Patient Partagé du Sénégal</h1>
		<a [routerLink]="getDossierPatientLink()"
			class="my-10 text-white bg-primary px-5 py-2 rounded-md inline-block">Mon dossier patient</a>
	</div>
	<div
		class="absolute bg-white bottom-0 right-0 w-full lg:w-1/2 rounded-tl-[60px] p-5 flex items-center justify-center">
		<h2 class="">Dossier Patient Partagé</h2>
	</div>
</header>

<section
	class="w-full min-h-[98vh] bg-[url('/images/hero2.png')] bg-cover bg-center bg-no-repeat -mt-1 flex flex-col justify-between relative">
	<div
		class="w-full lg:w-1/2 bg-white flex items-start justify-center flex-col py-14 px-7 lg:pl-[14rem] rounded-br-[60px] relative">
		<h3 class="mb-2">Valeur ajoutée de votre <br /><span class="text-primary">carnet de santé numérique</span></h3>
		<p class="mb-1 mt-3 text-sm">Le dossier Patient partagé (DPP) est une
			initiative du
			Sénégal à</p>
		<p class="mb-1 text-sm">travers le Ministère de la santé et de l'Action
			Sociale.</p>
		<p class="mb-1 text-sm">Le DPP vous donne un accès sécurisé à votre vie
			médicale en</p>
		<p class="mb-1 text-sm">consolidant toutes vos informations médicales pour
			une gestion et
		</p>
		<p class="mb-1 text-sm">une mise à disposition plus efficace de vos
			informations de santé.
		</p>
		<p class="mb-1 text-sm">Consultez vos diagnostics, ordonnances et
			prescriptions,</p>
		<p class="mb-1 text-sm">antécédents,... et facilitez la collaboration entre
			les
			professionnels</p>
		<p class="mb-1 text-sm">de la santé pour une prise en charge optimale de vos
			soins.</p>
	</div>
	<div class="container">
		<div class="mt-20 mb-3 flex items-center justify-between gap-4 flex-wrap">
			<h4 class="text-white">Que recherchez-vous ?</h4>
			<button class="btn-primary">Carnet Sanitaire</button>
		</div>
		<div class="grid grid-cols-1 lg:grid-cols-3 gap-3 bg-white min-h-[200px]">
			<div class="flex items-center gap-5 p-5 hover:bg-slate-50">
				<img class="w-20" src="images/pro-icon.svg" alt="">
				<div class="flex flex-col gap-1">
					<h5 class="text-primary">Médecins</h5>
					<p class="text-sm mt-1">Trouvez la liste des médecins agréés par le MSAS ainsi que leurs spécialités
						et
						d'autres
						informations
						pratiques.</p>
				</div>
			</div>
			<div class="flex items-center gap-5 p-5 hover:bg-slate-50">
				<img class="w-20" src="images/str-icon.svg" alt="">
				<div class="flex flex-col gap-1">
					<h5 class="text-primary">Structures de santé</h5>
					<p class="text-sm mt-1">Trouvez la liste des médecins agréés par le MSAS ainsi que leurs spécialités
						et
						d'autres
						informations
						pratiques.</p>
				</div>
			</div>
			<div class="flex items-center gap-5 p-5 hover:bg-slate-50">
				<img class="w-20" src="images/phar-icon.svg" alt="">
				<div class="flex flex-col gap-1">
					<h5 class="text-primary">Pharmacies</h5>
					<p class="text-sm mt-1">Trouvez la liste des médecins agréés par le MSAS ainsi que leurs spécialités
						et
						d'autres
						informations
						pratiques.</p>
				</div>
			</div>
		</div>
	</div>
	<div class="absolute bottom-0 left-0 h-1 w-full grid grid-cols-3">
		<div class="w-full h-full bg-green-600"></div>
		<div class="w-full h-full bg-yellow-300"></div>
		<div class="w-full h-full bg-red-600"></div>
	</div>
</section>

<div class="container">
	<section class="mt-20">
		<h3>Pourquoi choisir le Dossier Patient Partagé ?</h3>
		<div class="flex flex-col md:flex-row items-stretch bg-gradient-to-r from-white to-black pb-5 my-12">
			<img class="w-full md:w-2/5 object-cover h-[350px]" src="images/patient-card.png" alt="">
			<div class="flex-grow h-max bg-white min-h-[350px] py-7">
				<div class="bg-primary px-3 py-2 md:-ml-16">
					<h4 class="text-white">Vous êtes un patient ?</h4>
				</div>
				<ul class="py-5 px-7">
					<li class="flex items-center gap-x-4 my-2">
						<img class="w-2" src="icons/dot.svg" alt="">
						<p class="text-sm">Ne perdez plus de temps dans votre parcours de
							soins</p>
					</li>
					<li class="flex items-center gap-x-4 my-2">
						<img class="w-2" src="icons/dot.svg" alt="">
						<p class="text-sm">Ayez votre historique médical en tout temps et
							tout lieu</p>
					</li>
					<li class="flex items-center gap-x-4 my-2">
						<img class="w-2" src="icons/dot.svg" alt="">
						<p class="text-sm">Aidez votre médecin dans sa prise de
							décision</p>
					</li>
					<li class="flex items-center gap-x-4 my-2">
						<img class="w-2" src="icons/dot.svg" alt="">
						<p class="text-sm">Géolocalisez un professionnel de santé</p>
					</li>
					<li class="flex items-center gap-x-4 my-2">
						<img class="w-2" src="icons/dot.svg" alt="">
						<p class="text-sm">Améliorez votre suivi médical</p>
					</li>
					<li class="flex items-center gap-x-4 my-2">
						<img class="w-2" src="icons/dot.svg" alt="">
						<p class="text-sm">Faire mes démarches santé en ligne</p>
					</li>
				</ul>
			</div>
		</div>
		<div class="flex flex-col md:flex-row items-stretch bg-gradient-to-l from-white to-black pb-5 my-12">
			<img class="w-full md:w-2/5 object-cover h-[350px]" src="images/pro-card.png" alt="">
			<div class="flex-grow h-max bg-white min-h-[350px] py-7">
				<div class="bg-primary px-3 py-2 md:-ml-16">
					<h4 class="text-white">Vous êtes un professionnel ?</h4>
				</div>
				<ul class="py-5 px-7">
					<li class="flex items-center gap-x-4 my-2">
						<img class="w-2" src="icons/dot.svg" alt="">
						<p class="text-sm">Accédez à l'historique médical de votre patient</p>
					</li>
					<li class="flex items-center gap-x-4 my-2">
						<img class="w-2" src="icons/dot.svg" alt="">
						<p class="text-sm">Disposez des meilleures informations pour une prise de décision optimale</p>
					</li>
					<li class="flex items-center gap-x-4 my-2">
						<img class="w-2" src="icons/dot.svg" alt="">
						<p class="text-sm">Editez le dossier patient</p>
					</li>
					<li class="flex items-center gap-x-4 my-2">
						<img class="w-2" src="icons/dot.svg" alt="">
						<p class="text-sm"> Facilitez le parcours de soins de votre patient</p>
					</li>
				</ul>
			</div>
		</div>
	</section>

	<section class="flex items-center justify-center py-10 mb-5">
		<img class="w-56" src="images/sn-flag.svg" alt="">
	</section>
</div>
}

<!-- Landing page complexe (style Eyone/MSAS/CI/etc.) -->
@if (!useSimpleLandingStyle()) {
<header
	class="landing-section-bg pt-26 pb-10 md:pt-0 md:pb-0 md:h-[700px] flex items-center md:items-end justify-center">
	<div class="container flex items-end justify-between ">
		<div class="w-full md:w-3/5 pr-0 md:pr-12">
			<h1 class="text-[#343A40] !font-medium !text-[18px] md:!text-[40px] uppercase md:normal-case">Prenez votre
				santé
				en
				<span class="!font-semibold landing-accent-text">main</span>
			</h1>
			<p class="text-gray-400 text-[14px] md:text-[18px]">Vos données médicales à vos côtés.</p>

			<!-- Mobile: "Réservez tout de suite une consultation" label -->
			<div class="block md:hidden mb-2 mt-10">
				<h4 class="text-[#505D69] !font-medium !leading-3 !text-[14px] mb-4">
					Réservez tout de suite une consultation
				</h4>
			</div>
			<!-- Mobile search bar -->
			<div class="mb-10 block md:hidden">
				<form [formGroup]="searchForm" (ngSubmit)="onSearch()">
					<div class="relative mb-2">
						<input type="text" formControlName="town" placeholder="Rechercher un lieu"
							[matAutocomplete]="townAuto"
							(keydown.enter)="onSearchKeyDown($event)"
							class="h-14 px-2 pr-10 text-gray-500 rounded-lg border border-solid border-gray-200 placeholder:text-gray-400 placeholder:text-sm outline-none w-full !text-sm">
						<!-- Loader dans le champ ville (mobile) -->
						<div *ngIf="townLoading"
							class="pointer-events-none absolute inset-y-0 right-3 flex items-center justify-center">
							<span
								class="inline-block w-4 h-4 border-2 border-gray-300 border-t-primary rounded-full animate-spin"></span>
						</div>
						<!-- Bouton clear ville (mobile) -->
						<button *ngIf="hasTownValue && !townLoading" type="button" (click)="clearTown()"
							class="absolute inset-y-0 right-3 flex items-center justify-center w-8 h-full text-gray-500 hover:text-gray-700 focus:outline-none"
							aria-label="Effacer le lieu">
							<lucide-icon [img]="XIcon" class="w-4 h-4"></lucide-icon>
						</button>
						<mat-autocomplete #townAuto="matAutocomplete" [displayWith]="displayTownFn">
							<mat-option *ngIf="townLoading" disabled>Chargement...</mat-option>
							<mat-option *ngFor="let town of towns" [value]="town">{{ town.result }}</mat-option>
						</mat-autocomplete>
					</div>

					<div class="relative mb-2">
						<input type="text" formControlName="query" placeholder="Médecin, Structure, Pharmacies..."
							[matAutocomplete]="queryAuto"
							(keydown.enter)="onSearchKeyDown($event)"
							class="h-14 px-2 pr-10 text-gray-500 rounded-lg border border-solid border-gray-200 placeholder:text-gray-400 placeholder:text-sm outline-none w-full !text-sm">
						<!-- Loader dans le champ de recherche prestataire (mobile) -->
						<div *ngIf="queryLoading"
							class="pointer-events-none absolute inset-y-0 right-3 flex items-center justify-center">
							<span
								class="inline-block w-4 h-4 border-2 border-gray-300 border-t-primary rounded-full animate-spin"></span>
						</div>
						<!-- Bouton clear prestataire (mobile) -->
						<button *ngIf="hasQueryValue && !queryLoading" type="button" (click)="clearQuery()"
							class="absolute inset-y-0 right-3 flex items-center justify-center w-8 h-full text-gray-500 hover:text-gray-700 focus:outline-none"
							aria-label="Effacer la recherche">
							<lucide-icon [img]="XIcon" class="w-4 h-4"></lucide-icon>
						</button>
						<mat-autocomplete #queryAuto="matAutocomplete" [displayWith]="displayQueryFn"
							(optionSelected)="onQuerySelected($event)">
							<mat-option *ngIf="queryLoading" disabled>Chargement...</mat-option>
							<mat-option *ngFor="let query of results" [value]="query">
								{{ query.type === 'speciality' ? query.name : query.result }}
							</mat-option>
						</mat-autocomplete>
					</div>
					<button type="submit" [ngClass]="getSearchButtonClass()"
						class="w-full rounded-lg p-3 text-sm mt-5 cursor-pointer text-white">
						Rechercher
					</button>
				</form>
			</div>

			<!-- Desktop search bar -->
			<div class="my-10 hidden md:block">
				<h4 class="text-[#505D69] !font-medium !leading-3 !text-[14px]">Réservez tout de suite une consultation
				</h4>

				<div class="flex bg-white rounded-lg my-2 items-center h-16 overflow-visible shadow-sm">
					<div class="min-w-8/12" [formGroup]="searchForm">
						<div class="relative inline-block w-2/5 align-middle">
							<input type="text" formControlName="town" placeholder="Rechercher un lieu"
								[matAutocomplete]="townAuto"
								(keydown.enter)="onSearchKeyDown($event)"
								class="h-14 px-2 pr-8 text-gray-500 border-r border-solid border-gray-200 placeholder:text-gray-400 placeholder:text-sm outline-none w-full !text-sm">
							<!-- Loader dans le champ ville (desktop) -->
							<div *ngIf="townLoading"
								class="pointer-events-none absolute inset-y-0 right-2 flex items-center justify-center">
								<span
									class="inline-block w-4 h-4 border-2 border-gray-300 border-t-primary rounded-full animate-spin"></span>
							</div>
							<!-- Bouton clear ville (desktop) -->
							<button *ngIf="hasTownValue && !townLoading" type="button" (click)="clearTown()"
								class="absolute inset-y-0 right-2 flex items-center justify-center w-8 h-full text-gray-500 hover:text-gray-700 focus:outline-none"
								aria-label="Effacer le lieu">
								<lucide-icon [img]="XIcon" class="w-4 h-4"></lucide-icon>
							</button>
							<mat-autocomplete #townAuto="matAutocomplete" [displayWith]="displayTownFn">
								@if (townLoading) {
								<mat-option disabled>Chargement...</mat-option>
								} @else {
								@for (town of towns; track town.id) {
								<mat-option [value]="town">{{town.result}}</mat-option>
								}
								}
							</mat-autocomplete>
						</div>

						<div class="relative inline-block w-3/5 align-middle">
							<input type="text" formControlName="query" placeholder="Médecin, Structure, Pharmacies..."
								[matAutocomplete]="queryAuto"
								(keydown.enter)="onSearchKeyDown($event)"
								class="h-14 px-2 pr-8 text-gray-500 border-r border-solid border-gray-200 placeholder:text-gray-400 placeholder:text-sm outline-none w-full !text-sm">
							<!-- Loader dans le champ de recherche prestataire (desktop) -->
							<div *ngIf="queryLoading"
								class="pointer-events-none absolute inset-y-0 right-2 flex items-center justify-center">
								<span
									class="inline-block w-4 h-4 border-2 border-gray-300 border-t-primary rounded-full animate-spin"></span>
							</div>
							<!-- Bouton clear prestataire (desktop) -->
							<button *ngIf="hasQueryValue && !queryLoading" type="button" (click)="clearQuery()"
								class="absolute inset-y-0 right-2 flex items-center justify-center w-8 h-full text-gray-500 hover:text-gray-700 focus:outline-none"
								aria-label="Effacer la recherche">
								<lucide-icon [img]="XIcon" class="w-4 h-4"></lucide-icon>
							</button>
							<mat-autocomplete #queryAuto="matAutocomplete" [displayWith]="displayQueryFn"
								(optionSelected)="onQuerySelected($event)">
								@if (queryLoading) {
								<mat-option disabled>Chargement...</mat-option>
								} @else {
								@for (query of results; track query.id) {
								<mat-option [value]="query">{{query.type === 'speciality' ? query.name :
									query.result}}</mat-option>
								}
								}
							</mat-autocomplete>
						</div>
					</div>
					<button type="button" (click)="onSearch()"
						class="btn-search-primary h-full w-full text-white !font-normal !text-[14px] rounded-r-lg cursor-pointer">
						Rechercher
					</button>
				</div>
			</div>

			<div class="mt-14 -mb-14 hidden md:block">
				<h4 class="text-[#505D69] !font-medium !leading-3 !text-[14px]">Que recherchez-vous ?</h4>
				<div class="flex gap-4 mt-4">
					<button type="button" (click)="selectSearchCategory('medecins')"
						[ngClass]="getCategoryButtonClass('medecins')"
						class=" px-4 flex justify-center items-center rounded-lg h-32 w-44 text-lg font-medium shadow-0 border-0 cursor-pointer">
						<h5 [ngClass]="getCategoryButtonClass('medecins') === 'btn-category-primary' ? 'text-white' : 'text-gray-700'"
							class="!text-[16px] !font-normal">Professionnels</h5>
					</button>
					<button type="button" (click)="selectSearchCategory('structures')"
						[ngClass]="getCategoryButtonClass('structures')"
						class="px-4 flex justify-center items-center rounded-lg h-32 w-44 text-lg font-medium shadow-0 border-0 cursor-pointer">
						<h5 [ngClass]="getCategoryButtonClass('structures') === 'btn-category-primary' ? 'text-white' : 'text-gray-700'"
							class="!text-[16px] !font-normal">Hôpitaux & Cliniques</h5>
					</button>
					<button type="button" (click)="selectSearchCategory('pharmacies')"
						[ngClass]="getCategoryButtonClass('pharmacies')"
						class="px-4 flex justify-center items-center rounded-lg h-32 w-44 text-lg font-medium shadow-0 border-0 cursor-pointer">
						<h5 [ngClass]="getCategoryButtonClass('pharmacies') === 'btn-category-primary' ? 'text-white' : 'text-gray-700'"
							class="!text-[16px] !font-normal">Pharmacies</h5>
					</button>
				</div>
			</div>

			<!-- Separator -->
			<div class="my-6 flex items-center md:hidden">
				<div class="flex-grow border-t border-gray-200"></div>
			</div>

			<!-- Mobile: "Que recherchez-vous ?" label -->
			<div class="block md:hidden mb-2">
				<h4 class="text-[#505D69] !font-medium !leading-3 !text-[14px] mb-4">Que recherchez-vous ?</h4>
				<div class="flex flex-col gap-4">
					<button type="button" (click)="selectSearchCategory('medecins')"
						[ngClass]="getCategoryButtonClass('medecins')"
						class="px-4 flex justify-center items-center rounded-lg h-32 w-full text-lg font-medium shadow-0 border-0 cursor-pointer">
						<h5 [ngClass]="getCategoryButtonClass('medecins') === 'btn-category-primary' ? 'text-white' : 'text-gray-700'"
							class="!text-[16px] !font-normal">Professionnels</h5>
					</button>
					<button type="button" (click)="selectSearchCategory('structures')"
						[ngClass]="getCategoryButtonClass('structures')"
						class="px-4 flex justify-center items-center rounded-lg h-32 w-full text-lg font-medium shadow-0 border-0 cursor-pointer">
						<h5 [ngClass]="getCategoryButtonClass('structures') === 'btn-category-primary' ? 'text-white' : 'text-gray-700'"
							class="!text-[16px] !font-normal">Hôpitaux & Cliniques</h5>
					</button>
					<button type="button" (click)="selectSearchCategory('pharmacies')"
						[ngClass]="getCategoryButtonClass('pharmacies')"
						class="px-4 flex justify-center items-center rounded-lg h-32 w-full text-lg font-medium shadow-0 border-0 cursor-pointer">
						<h5 [ngClass]="getCategoryButtonClass('pharmacies') === 'btn-category-primary' ? 'text-white' : 'text-gray-700'"
							class="!text-[16px] !font-normal">Pharmacies</h5>
					</button>
				</div>
			</div>
		</div>
		<div class="w-2/5 hidden md:block">
			<img src="images/babette.png" alt="babette" class="h-auto w-88">
		</div>
	</div>
</header>

<section class="bg-white pt-40">
	<div class="container">
		<div class="flex flex-col items-center">
			<p class="landing-primary-text text-sm font-bold">Pourquoi choisir le {{ getProductName() }} ?</p>
			<h3 class="relative text-base-100 z-10 !text-[20px]">
				<span class="relative z-10 text-[18px] !font-[500]">Vous êtes un patient ?</span>
				<span
					class="pointer-events-none absolute left-1/2 -translate-x-1/2 top-3/5 -translate-y-1/2 z-0 block landing-highlight-bg h-[14px] w-[250px] rounded"></span>
			</h3>
			<div class="w-full grid grid-cols-1 md:grid-cols-2 gap-5 my-12">
				<div class="flex items-center justify-center">
					<img src="images/patient1.png" alt="patient1" class="w-auto h-80 object-cover">
				</div>
				<div class="space-y-6 px-0 md:px-10 my-auto">
					<div class="flex items-center gap-4">
						<div
							class="w-8 h-8 landing-number-bg rounded-full font-[500] flex items-center justify-center text-gray-500 text-sm">
							1</div>
						<p class="text-gray-500 !text-[14px]">Ne perdez plus de temps à attendre</p>
					</div>
					<div class="flex items-center gap-4">
						<div
							class="w-8 h-8 landing-number-bg rounded-full font-[500] flex items-center justify-center text-gray-500 text-sm">
							2</div>
						<p class="text-gray-500 !text-[14px]">Ayez votre historique médical en tout temps et tout lieu
						</p>
					</div>
					<div class="flex items-center gap-4">
						<div
							class="w-8 h-8 landing-number-bg rounded-full font-[500] flex items-center justify-center text-gray-500 text-sm">
							3</div>
						<p class="text-gray-500 !text-[14px]">Aidez votre médecin dans sa prise de décision</p>
					</div>
					<div class="flex items-center gap-4">
						<div
							class="w-8 h-8 landing-number-bg rounded-full font-[500] flex items-center justify-center text-gray-500 text-sm">
							4</div>
						<p class="text-gray-500 !text-[14px]">Géolocalisez un professionnel de santé</p>
					</div>
					<div class="flex items-center gap-4">
						<div
							class="w-8 h-8 landing-number-bg rounded-full font-[500] flex items-center justify-center text-gray-500 text-sm">
							5</div>
						<p class="text-gray-500 !text-[14px]">Améliorez votre suivi médical</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<section class="py-16 landing-section-bg">
	<div class="container">
		<div class="flex flex-col items-center">
			<div>
				<h3 class="relative text-base-100 z-10 !text-[20px]">
					<span class="relative z-10 text-[18px] !font-[600]">Vous êtes un professionnel ?</span>
					<span
						class="pointer-events-none absolute left-1/2 -translate-x-1/2 top-3/5 -translate-y-1/2 z-0 block landing-highlight-bg h-[14px] w-[250px] rounded"></span>
				</h3>
			</div>
			<div class="w-full grid grid-cols-1 md:grid-cols-2 gap-5 my-12">
				<div class="flex items-center justify-center">
					<img src="images/doctor2.png" alt="patient1" class="w-auto h-80 object-cover">
				</div>
				<div class="space-y-6 px-0 md:px-10 my-auto">
					<div class="flex items-center gap-4">
						<div
							class="w-8 h-8 landing-number-bg rounded-full font-[500] flex items-center justify-center text-gray-500 text-sm">
							1</div>
						<p class="text-gray-500 !text-[14px]">Gagnez en visibilité</p>
					</div>
					<div class="flex items-center gap-4">
						<div
							class="w-8 h-8 landing-number-bg rounded-full font-[500] flex items-center justify-center text-gray-500 text-sm">
							2</div>
						<p class="text-gray-500 !text-[14px]">Optimisez la gestion de votre facturation</p>
					</div>
					<div class="flex items-center gap-4">
						<div
							class="w-8 h-8 landing-number-bg rounded-full font-[500] flex items-center justify-center text-gray-500 text-sm">
							3</div>
						<p class="text-gray-500 !text-[14px]">Maîtrisez en temps réel votre activité</p>
					</div>
					<div class="flex items-center gap-4">
						<div
							class="w-8 h-8 landing-number-bg rounded-full font-[500] flex items-center justify-center text-gray-500 text-sm">
							4</div>
						<p class="text-gray-500 !text-[14px]">Interagissez avec vos patients</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
}